var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableSortingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "table_sort_down",
    "data-name": "table sort down",
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 9.999,
    viewBox: "0 0 6 9.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_sort_2448726_000000",
    transform: "translate(-25.005 -15.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table_sorting",
    transform: "translate(25.009 15.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M.407,3.74c.312-.374-.473.071-.163.071H5.767a.249.249,0,0,0,.171-.418C5.626,3.02,5.317,2.646,5,2.272Q4.259,1.378,3.517.484C3.4.347,3.289.211,3.174.071a.236.236,0,0,0-.338,0C2.524.445,2.214.819,1.9,1.192Q1.157,2.086.415,2.981c-.115.137-.228.273-.343.413a.253.253,0,0,0,0,.344.23.23,0,0,0,.336,0Z",
    transform: "translate(-0.004 0)",
    fill: "#419AE8",
    opacity: 0.45
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10036",
    "data-name": "Path 10036",
    d: "M25.074,56.074c.312.374.621.748.934,1.121q.745.894,1.487,1.788c.115.137.228.273.343.413a.236.236,0,0,0,.338,0c.312-.374.621-.748.934-1.121q.745-.894,1.487-1.788c.115-.137.228-.273.343-.413a.249.249,0,0,0-.171-.418H25.246a.245.245,0,0,0,0,.489c5.466-.139-.089-.506-.175-.418a.258.258,0,0,0,0,.347Z",
    transform: "translate(-25.005 -49.468)",
    fill: "#163f68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSortingDown);
export default __webpack_public_path__ + "static/media/table-sorting-down.016f54cf12870193522d908695a2a109.svg";
export { ForwardRef as ReactComponent };